module.exports = __webpack_public_path__ + "img/icon-inbox.b109b2c6.png";